import { useServiceWorkerUpdate } from '@/hooks/useServiceWorkerUpdate'
import { Button } from '@/components/ui/button'
import { RefreshCw, X } from 'lucide-react'
import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

export function UpdatePrompt() {
  const { updateAvailable, update } = useServiceWorkerUpdate()
  const [dismissed, setDismissed] = useState(false)

  return (
    <AnimatePresence>
      {updateAvailable && !dismissed && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:bottom-4 md:left-auto md:right-4 md:w-80 md:p-0"
        >
          <div className="flex items-center gap-3 rounded-lg border bg-background p-4 shadow-lg">
            <RefreshCw className="h-5 w-5 shrink-0 text-primary" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">Update available</p>
              <p className="text-xs text-muted-foreground">A new version is ready to install.</p>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <Button size="sm" onClick={update}>
                Update
              </Button>
              <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setDismissed(true)}>
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
